Service = App.loadClass 'core::Angular/Service'

exports.register = (module) ->
    module.service 'Core.Services.Routing', [
        '$state'
        '$location'
        '$http'
        '$window'
        'localStorageService'
        'Core.Services.Session'
        exports.Routing
    ]

class exports.Routing extends Service
    constructor: (@state, @location, @http, @window, @localStorage, @session) ->
        undefined

    findAppByReferrer: (referrer) =>
        # Don't know where to go? Why not ~zoidberg~ dashboard?
        return 'dashboard' if not referrer

        environments =
            portal: ['rportal.*', 'portal.*', 'portal.myfarms.*', 'testportal.*']
            admin: ['radmin.*', 'admin.*', 'admin.myfarms.*', 'testadmin.*']
            grower: ['rdev.*', 'grower.*', 'localhost.*', 'myfarms.*']

        for environment, domains of environments
            for domain in domains
                if referrer.match(new RegExp(domain))
                    return environment

        # Maybe this should be grower instead?
        'dashboard'

    determineDestination: (stateParams = {}) =>
        # if we have a registration token auto-link accounts
        if stateParams.registration_token
            @http.post 'backend/core/grower-registration/auto-link', { token: stateParams.registration_token }

        # Things we need:
        # - ?b= flag
        # - HTTP_REFERRER
        # - Default experience (app + company)
        # - List of experiences (app + company)
        #
        # If we have ?b=
        #   Set that company
        #   Continue loading the app for the referring site
        # Else
        #   If the user has a default experience
        #       Go to that experience
        #   If the user has one experience for the referring site
        #       Go to that experience
        #   If the user has one experience overall
        #       Go to that experience
        #   Else
        #       Show to the dashboard with all the experiences
        if @localStorage.get('previous_location')?
            location = @localStorage.get('previous_location').href
            @localStorage.remove 'previous_location'
            @window.location = location

        @http.post '/backend/get-experiences'
        .then (response) =>
            # console.log 'did not catch rejection, beginning routing logic'
            branding = stateParams.b
            referrer = stateParams.r
            referringApp = @findAppByReferrer referrer

            # If we have ?b=
            if branding
                @session.set "SelectedCompany-#{referringApp}", branding
                # console.log "we had branding. go to #{referringApp} with branding #{branding}"
                return @goToState referringApp

            userData = response.data.data

            # If the user has one experience for the referring site
            if referringApp and referringApp isnt 'dashboard'
                count = 0
                selectedExperience = null
                for experience in userData.experiences
                    # Uses text because of TouchPoint
                    if experience.text.toLowerCase() is referringApp
                        count++
                        selectedExperience = experience
                if count is 1
                    @session.set "SelectedCompany-#{referringApp}", selectedExperience.company
                    return @goToState referringApp

                # If you have more than one experience for the referringApp and a default company selected, use that
                if count > 1 and userData.defaultCompany
                    @session.set "SelectedCompany-#{referringApp}", userData.defaultCompany
                    return @goToState referringApp

            # If the user has a default experience
            if userData.defaultCompany and userData.defaultDomain
                desiredState = userData.defaultDomain.toLowerCase()
                # console.log "user has a default experience: #{desiredState}"
                @session.set "SelectedCompany-#{desiredState}", userData.defaultCompany
                return @goToState desiredState

            # If the user has one experience overall
            if userData.experiences.length is 1
                desiredState = userData.experiences[0].text.toLowerCase()
                # console.log "user has only one experience: #{desiredState}"
                @session.set "SelectedCompany-#{desiredState}", userData.experiences[0].company
                return @goToState desiredState

            # console.log "we don't know where to go, so go to the dashboard site"
            @state.go 'dashboard'

    goToState: (state) =>
        unless @state.includes state
            @state.go state
